import { Action, Dispatch } from 'redux';
import * as api from '../core/api/api';
import * as appServiceLines from '../core/service-lines';
import * as codeBenchActions from './code-bench.actions';
import * as commonActions from './action-types';
import * as commonEnums from '../enums/index';
import HttpMethods from '../enums/http-methods';
import { createAction } from '@reduxjs/toolkit';
import { emptyPageable } from '../core/amplify/utils/pagination-utils';

const { Launch } = commonActions;
const { FilterTypes } = commonEnums;

export const caseRunAvailable = createAction<CMxAPI.CaseRun>(Launch.CASE_DETAIL);
export const billingGroupAvailable = createAction<CMxAPI.PageableList<CMxAPI.Case>>(
  Launch.BILLING_GROUP
);

export const getBillingGroup = async (billingGroupId, dispatch) => {
  // TORESOLVE: This will need to be paramd for the service line.
  const searchParams = new URLSearchParams({
    page: '0',
    pageSize: '25',
    sort: 'dateOfService,DESC'
  });

  searchParams.append('sort', 'id,DESC');

  let body: any[] = [];

  body.push({
    key: `billing_group_id`,
    terms: [`${billingGroupId}`],
    type: FilterTypes.EQ
  });

  const slPath = appServiceLines.get().path;
  const { caseListVersion } = appServiceLines.get();

  const billingGroupPageable = await api.requestJSON<
    CMxAPI.PageableList<CMxAPI.Case>
  >(
    `${slPath}/caseinstance/list/${caseListVersion}?${searchParams.toString()}`,
    {
      method: HttpMethods.POST,
      body: JSON.stringify(body)
    }
  );

  dispatch(billingGroupAvailable(billingGroupPageable));

  return billingGroupPageable;
};

export const loadCase = async (
  caseRun: CMxAPI.CaseRun,
  dispatch: Dispatch<Action>,
  guidMode = 'false'
): Promise<{ url: string }> => {
  const launchConfig = {
    serviceLine: appServiceLines.toServiceLineSlug(String(caseRun.service_line ?? '')),
    caseId: guidMode === 'true' ? caseRun.case_uid : caseRun.case_id,
    processId:
      guidMode === 'true'
        ? caseRun.process_instance_guid
        : caseRun.process_instance_id
  };

  await loadCaseCall(caseRun, dispatch);

  return {
    url: `/${launchConfig.serviceLine}/case/${launchConfig.caseId}/case-run/${launchConfig.processId}`
  };
};

export const loadCaseFromURL = async (
  caseRun: CMxAPI.CaseRun,
  dispatch: Dispatch<Action>
) => {
  return await loadCaseCall(caseRun, dispatch);
};

export const loadCaseCall = async (
  caseRun: CMxAPI.CaseRun,
  dispatch: Dispatch<Action>
) => {
  dispatch(caseRunAvailable(caseRun));

  const promises = [];
  // three async actions that happen in parallel
  // 1. get a billing group
  // 2. get the code descriptions - neither of which is blocking.
  // 3. get the code-bench layout configuration
  if (caseRun.billing_group_id) {
    const billingGroup = getBillingGroup(caseRun.billing_group_id, dispatch);
    promises.push(billingGroup);
  } else {
    dispatch(billingGroupAvailable(emptyPageable));
  }

  // Fetch code-bench layout configuration
  if (caseRun.tenant_name && caseRun.service_line) {
    const fetchCodeBenchConfig = async () => {
      try {
        /*
          The below throws this error:
            TS2345: Argument of type 'ThunkFunctionAction<any, BenchApplicationState, unknown>' is not assignable to parameter of type 'Action<string>'.
          Ensure why, added a ts-ignore, seems to work otherwise.
         */
        dispatch(
          // @ts-ignore
          codeBenchActions.fetchCodeBenchLayoutConfiguration({
            tenantId: caseRun.tenant_uid,
            serviceLine: caseRun.service_line
          })
        );
      } catch (error) {
        console.warn('Failed to fetch code-bench layout configuration:', error);
      }
    };
    promises.push(fetchCodeBenchConfig());
  }

  await Promise.all(promises);
  return;
};
